import { Component, inject, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.css'
})
export class MainLayoutComponent {
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);
  
  protected user = this.authService.user;
  protected isMobileMenuOpen = signal(false);
  protected isNotificationsOpen = signal(false);
  protected notifications = this.notificationService.notifications;
  protected unreadCount = this.notificationService.unreadCount;
  
  protected initials = computed(() => {
    const name = this.user()?.name || '';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
  });

  ngOnInit(): void {
    this.notificationService.getUpcoming().subscribe();
  }

  protected logout(): void {
    this.authService.logout();
  }
}
